import Component from './components/PrivateRoute';

export default Component;
